<template>
<div id="paypal-button"></div>
</template>

<script>
import axios from 'axios';
import paypal from 'paypal-checkout';

export default {
  props: {
    credit: {
      type: Number,
      required: true,
    },
    commit: {
      type: Boolean,
      required: false,
      default: true,
    },
    dev: {
      type: Boolean,
      required: false,
    },
    buttonStyle: {
      type: Object,
      required: false,
      validator: (value) => {
        const isValid = (item, options) => (options.some(v => (v === item)));
        const copy = Object.assign({}, value);
        const options = {
          size: ['tiny', 'small', 'medium', 'responsive'],
          color: ['gold', 'blue', 'silver'],
          shape: ['pill', 'rect'],
        };

        Object.keys(options).forEach((key) => {
          const item = copy[key];
          const valid = isValid(item, options[key]);

          if (!valid) {
            // eslint-disable-next-line
            console.warn(`style.${key} = '${item}' isn't a valid option`, options[key]);
            return false;
          }

          return true;
        });

        return true;
      },
    },
    validate: {
      type: Function,
      required: false,
    },
  },
  computed: {
    env() {
      return (this.dev) ? 'sandbox' : 'production';
    },
  },
  methods: {
    PayPalPayment() {
      return axios.post('/api/payment/paypal', { credit: this.credit })
      .then((response) => {
        const data = response.data;
        console.log(data);
        return data.paymentID;
      }).catch((error) => {
        console.log(error);
      });
    },
    onAuthorize(data, actions) {
      return actions.redirect();
    },
    onCancel(data, actions) {
      return actions.redirect();
    },
  },
  mounted() {
    const vue = this;

    const buttonObject = {
      // Pass in env
      env: vue.env,

      validate: vue.validate,

      // Pass the payment details for your transaction
      // See https://developer.paypal.com/docs/api/payments/#payment_create for the expected json parameters
      payment: vue.PayPalPayment,

      // Display a "Pay Now" button rather than a "Continue" button
      commit: vue.commit,

      // Pass a function to be called when the customer completes the payment
      onAuthorize: vue.onAuthorize,

      // Pass a function to be called when the customer cancels the payment
      onCancel: vue.onCancel,
    };

    // validate style prop
    if (vue.buttonStyle !== undefined) {
      buttonObject.style = vue.buttonStyle;
    }

    paypal.Button.render(buttonObject, '#paypal-button');
  },
};
</script>



// WEBPACK FOOTER //
// PaypalCheckout.vue?e96f6c3c